import request from '@/utils/service'

// 问题类型
export function typeListApi(data) {
  return request({
    url: '/questionCategory/list',
    method: 'get',
    params: data
  })
}

export function updatedQuestionTypeApi(data) {
  return request({
    url: '/questionCategory/update',
    method: 'post',
    data
  })
}

export function addQuestionTypeApi(data) {
  return request({
    url: '/questionCategory/add',
    method: 'post',
    data
  })
}

export function delQuestionTypeApi(data) {
  return request({
    url: '/questionCategory/delete',
    method: 'post',
    data
  })
}
// 问题

export function listApi(data) {
  return request({
    url: '/question/list',
    method: 'get',
    params: data
  })
}

export function addQuestionApi(data) {
  return request({
    url: '/question/add',
    method: 'post',
    data
  })
}

export function updateQuestionApi(data) {
  return request({
    url: '/question/update',
    method: 'post',
    data
  })
}

export function deleteQuestion(data) {
  return request({
    url: '/question/delete',
    method: 'post',
    data
  })
}
